import { stripEmojis } from "../../utils";

const ReviewsTab = ({ reviews = [], reviewsCount = 0 }) => {
  const avgRating =
    reviews.length > 0
      ? (
          reviews.reduce((sum, r) => sum + Number(r.rating || 0), 0) /
          reviews.length
        ).toFixed(1)
      : "0.0";

  const ratingBreakdown = [5, 4, 3, 2, 1].map((star) => {
    const count = reviews.filter(
      (r) => Math.round(Number(r.rating)) === star,
    ).length;
    const pct =
      reviews.length > 0 ? ((count / reviews.length) * 100).toFixed(1) : "0";
    return { star, count, pct };
  });

  const timeAgo = (dateStr) => {
    if (!dateStr) return "";
    const diff = Math.floor((new Date() - new Date(dateStr)) / 1000);
    if (diff < 60) return "Just now";
    if (diff < 3600) return `${Math.floor(diff / 60)} mins ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} hours ago`;
    if (diff < 86400 * 7) return `${Math.floor(diff / 86400)} days ago`;
    return new Date(dateStr).toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <div className="tab-reviews write-cancel-review-wrap">
      {/* ── Ratings Summary ── */}
      <div className="tab-reviews-heading">
        <div className="top">
          <div className="text-center">
            <h1 className="number fw-6">{avgRating}</h1>
            <div className="list-star">
              {[1, 2, 3, 4, 5].map((s) => (
                <i
                  key={s}
                  className={`icon icon-star${s <= Math.round(Number(avgRating)) ? "" : "-empty"}`}
                />
              ))}
            </div>
            <p>({reviewsCount} Ratings)</p>
          </div>

          <div className="rating-score">
            {ratingBreakdown.map(({ star, count, pct }) => (
              <div key={star} className="item">
                <div className="number-1 text-caption-1">{star}</div>
                <i className="icon icon-star" />
                <div className="line-bg">
                  <div style={{ width: `${pct}%` }} />
                </div>
                <div className="number-2 text-caption-1">{count}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Reviews List ── */}
      <div className="reply-comment cancel-review-wrap">
        <div className="d-flex mb_24 gap-20 align-items-center justify-content-between flex-wrap">
          <h5>
            {reviewsCount} Comment{reviewsCount !== 1 ? "s" : ""}
          </h5>
        </div>

        {reviews.length === 0 && (
          <p style={{ color: "#888", fontSize: 14 }}>
            No reviews yet. Be the first to review this product! 🌈
          </p>
        )}

        <div className="reply-comment-wrap">
          {reviews
            .sort((a, b) => new Date(b.reviewed_at) - new Date(a.reviewed_at))
            .map((review, i) => (
              <div key={review.id || i} className="reply-comment-item">
                <div className="user">
                  <div
                    className="image"
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: "50%",
                      backgroundColor: "#2c3a34",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 16,
                      fontWeight: 700,
                      flexShrink: 0,
                    }}
                  >
                    {(review.customer_name ||
                      review.reviewer_name ||
                      "U")[0].toUpperCase()}
                  </div>
                  <div>
                    <h6>
                      <a href="#" className="link">
                        {review.reviewer_name || "Anonymous"}
                      </a>
                    </h6>
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <div style={{ display: "flex", gap: 2 }}>
                        {[1, 2, 3, 4, 5].map((s) => (
                          <span
                            key={s}
                            style={{
                              fontSize: 12,
                              color:
                                s <= Number(review.rating) ? "#f5a623" : "#ddd",
                            }}
                          >
                            ★
                          </span>
                        ))}
                      </div>
                      <span
                        style={{
                          fontSize: 10,
                          fontWeight: 700,
                          color: "#2e7d32",
                          backgroundColor: "#e8f5e9",
                          padding: "1px 6px",
                          textTransform: "uppercase",
                          letterSpacing: 0.3,
                        }}
                      >
                        ✓ Verified Purchase
                      </span>
                    </div>
                    <div className="day text_black-2">
                      {timeAgo(review.reviewed_at || review.date)}
                    </div>
                  </div>
                </div>
                <p className="text_black-2">
                  {stripEmojis(
                    review.body || review.comment || review.review || "",
                  )}
                </p>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ReviewsTab;
